<template>
  <div class="sort-item">
    <img
v-if="type === fileType.IMAGE"
:src="url"
alt="href">
    <video v-else-if="type === fileType.VIDEO">
      <source :src="url">
    </video>
  </div>
</template>

<script>
import constants from "@/config/constants";
export default {
  name: "SortItem",
  props: {
    type: String,
    url: {
      type: String,
    },
  },
  data() {
    return {
      fileType: constants.FILE_TYPE,
    };
  },
};
</script>
vue-js-grid
<style lang="scss">
@keyframes shake {
  from {
    transform: rotate(-2deg);
  }
  to {
    transform: rotate(2deg);
  }
}

.sort-item {
  background-size: cover;
  position: relative;
  background-color: transparent;
  margin: 10px;
  height: 90%;
  border-radius: 10px;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.07);
  color: #777;
  font-weight: 900;
  font-size: 12px;
  line-height: 52px;
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;
  img,
  video {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    object-fit: cover;
    pointer-events: none;
  }
}

.v-grid-item-dragging .sort-item {
  animation-name: shake;
  animation-duration: 0.08s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
</style>
